import { selectApp } from './selectApp';

export const selectShowIndustryBranchFields = (state) => selectApp(state).showIndustryBranchFields;
